"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bold = exports.Text = exports.Color = exports.H3Alternate = exports.H2Subtitle = exports.H1Subtitle = exports.H3 = exports.H2 = exports.H1 = exports.BodySmallTransparent = exports.BodyCapital = exports.BodyLarger = exports.BodyLarge = exports.Body = exports.BodySmall = exports.BodySmaller = exports.BodyExtraSmall = exports.FontWeight = void 0;

var web_1 = require("@thesisedu/web");

var FontWeight;

(function (FontWeight) {
  FontWeight[FontWeight["Light"] = 300] = "Light";
  FontWeight[FontWeight["Normal"] = 400] = "Normal";
  FontWeight[FontWeight["SemiBold"] = 500] = "SemiBold";
  FontWeight[FontWeight["Bold"] = 600] = "Bold";
  FontWeight[FontWeight["ExtraBold"] = 800] = "ExtraBold";
})(FontWeight = exports.FontWeight || (exports.FontWeight = {}));

exports.BodyExtraSmall = web_1.BodySmaller;
exports.BodySmaller = web_1.BodySmaller;
exports.BodySmall = web_1.BodySmall;
exports.Body = web_1.Body;
exports.BodyLarge = web_1.BodyLarge;
exports.BodyLarger = web_1.BodyLarger;
exports.BodyCapital = web_1.BodyCapital;
exports.BodySmallTransparent = web_1.BodySmallTransparent;
exports.H1 = web_1.H1;
exports.H2 = web_1.H2;
exports.H3 = web_1.H3;
exports.H1Subtitle = web_1.H1Subtitle;
exports.H2Subtitle = web_1.H2Subtitle;
exports.H3Alternate = web_1.H3Alternate;
exports.Color = web_1.Color;
exports.Text = web_1.styled.span(_templateObject());
exports.Bold = web_1.styled.strong(_templateObject2());